<template>
    <section id="handover-data">
        <div class="list-group-item collapse-element d-flex justify-content-between align-items-center">
            <b>{{ $t('co.delivery_data.variable-title', { currentStep: currentStep, steps: numberOfSteps }) }}</b>
            <b-button variant="text" v-if="!isVisible" @click="openCollapse">
                <font-awesome-icon icon="far fa-pencil" />
            </b-button>
        </div>
        <b-collapse class="list-group-item checkout-payment-box " tag="div" v-model="isVisible">
            <div class="row">
                <div class="col-12 my-2">
                    <b-form-radio-group v-model="option" inline>
                        <b-form-radio v-if="this.entry.delivery.deliveryCosts > 0" value="delivery">
                            {{ $t('co.delivery_data.delivery') }}
                        </b-form-radio>
                        <b-form-radio value="pickup">
                            {{ $t('co.delivery_data.pickup') }}
                        </b-form-radio>
                    </b-form-radio-group>
                    <div class="my-2">
                        <b>{{ $t('checkout.desired_date') }}</b>
                        <b-form-datepicker v-model="targetDate" :min="minDate" :initial-date="minDate" class="mb-2"></b-form-datepicker>
                    </div>
                    <span v-if="this.entry.delivery.deliveryCosts > 0">
                        <p v-if="option == 'delivery'">{{ $t('co.delivery_data.price') }} <b>{{ getPrice }}</b></p>
                    </span>
                    <span v-if="this.entry.delivery.deliveryCosts <= 0">
                        <p>{{ $t('co.delivery_data.zero_delivery_cost.error') }}</p>
                    </span>
                </div>
            </div>
            <div class="row d-flex justify-content-end mt-4">
                <div class="col-12 d-flex justify-content-end">
                    <button type="button" class="btn btn-primary btn-mobile-full-width" @click="submit" v-if="!isSubmitting">{{$t('co.button.continue')}}</button>
                    <button type="button" class="btn btn-primary btn-mobile-full-width disabled" v-else>{{$t('co.button.loading')}}</button>
                </div>
            </div>
        </b-collapse>
    </section>
</template>

<script>
import { BFormRadio, BCollapse, BFormRadioGroup, BButton, BFormDatepicker } from 'bootstrap-vue'
import { EventBus } from '../../event-bus'

export default {
    name: 'CheckoutHandoverData',
    components: {
        BFormRadio, BFormRadioGroup, BFormDatepicker,
        BCollapse,
        BButton,
    },
    props: {
        entry: null,
        product: null,
        currentStep: {
            type: Number,
        },
        numberOfSteps: {
            type: Number,
        },
    },
    data() {
        return {
            isVisible: false,
            option: 'delivery',
            targetDate: null,
            isSubmitting: false,
            error: false,
        }
    },
    methods: {
        initFields() {
            this.option = this.entry.delivery.deliveryOption ? this.entry.delivery.deliveryOption : 'pickup'
        },
        submit() {
            if (this.isSubmitting) {
                return
            }

            let body = {}

            if (this.option === "delivery") {
                body = {
                    delivery_method: this.option,
                    subscription_uuid: this.entry.uuid,
                    delivery_cost: this.entry.delivery.deliveryCosts,
                    delivery_option: this.product.subsidiary.delivery_option,
                    targetDate: this.targetDate
                }
            } else {
                body = {
                    delivery_method: this.option,
                    subscription_uuid: this.entry.uuid,
                    delivery_option: 'no_delivery',
                    targetDate: this.targetDate
                }
            }

            this.isSubmitting = true
            this.$axios.put('api/v1/checkout/update_subscription', body).then(response => {
                if (response.data) {
                    if (response.data == 'vehicle_not_available') {
                        alert(this.$t('checkout.redirect_error'))
                        this.$router.push('/')
                    }

                    this.googleAnalyticsDeliveryEvent()
                    this.isVisible = false
                    EventBus.$emit('checkout-open-step-' + (this.currentStep + 1), null)
                    document.getElementById('payment-data').scrollIntoView()
                } else {
                    this.error = true
                }

                this.isSubmitting = false
            }).catch(error => {
                this.isSubmitting = false
                this.error = true
            });
        },
        googleAnalyticsDeliveryEvent() {
            if (process.env.MIX_VUE_APP_ACTIVATE_GOOGLE_ANALYTICS && this.$gtag !== undefined) {
                this.$gtag.event('add_shipping_info', {
                    currency: this.entry.price_plan.currency.toUpperCase(),
                    shipping_method: this.option,
                    items: [
                        {
                            item_id: this.product.id,
                            item_name: this.product.model.title,
                            item_brand: this.product.brand.title,
                            item_category: this.product.category.title,
                            subsidiary_id: this.$root.whitelabel.sub_id(),
                            price: this.entry.price_plan.price,
                            mileage: localStorage.selectedMileage,
                            duration: localStorage.selectedDuration
                        }
                    ]
                })
            }
        },
        init() {
            this.isVisible = true
        },
        openCollapse() {
            EventBus.$emit('close-all-collapses', null)
            this.$nextTick(() => {
                this.init()
            })
        },
        closeCollapse() {
            this.isVisible = false
        }
    },
    computed: {
        getPrice() {
            const price = this.$root.whitelabel.setting('show_price_without_taxes') ? this.entry.delivery.deliveryCosts_net : this.entry.delivery.deliveryCosts
            const vatText = this.$root.whitelabel.setting('show_price_without_taxes') ? this.$t('general.net') : ''
            return `${this.$root.whitelabel.getFormatetPrice(price)} ${vatText}`
        },
        minDate() {
            let date = new Date()
            if (!this.product?.available_weeks) {
                date.setDate(new Date().getDate() + 7)
                return date
            }

            date.setDate(new Date().getDate() + (this.product.available_weeks * 7))
            return date
        }
    },
    mounted() {
        EventBus.$on('close-all-collapses', this.closeCollapse)
        EventBus.$on('checkout-open-step-' + this.currentStep, this.init);
    },
    watch: {
        entry() {
            if (this.entry !== null) {
                this.initFields()
            }
        },
        product() {
            if (this.product !== null) {
                this.targetDate = this.minDate
            }
        }
    },
}
</script>
